import React from 'react'
import { useSelector } from 'react-redux'
import { Menu } from 'util/ui'
import { START_OF_REPORTS } from 'ducks/reports/constants'
import { selectTimezone } from 'ducks/reports/controls/selectors'
import BusinessHoursControl from '../BusinessHoursControl'
import DateControl from '../DateControl'
import styles from './styles.less'

export default function ControlBar({ prerenderDatePicker }) {
  const timezone = useSelector(selectTimezone)

  return (
    <Menu fixed="top" className={styles.ControlBar}>
      <Menu.Menu position="left">
        <Menu.Item fitted>
          <BusinessHoursControl />
        </Menu.Item>
      </Menu.Menu>
      <Menu.Menu position="left">
        <Menu.Item>
          <i>Timezone Used: {timezone}</i>
        </Menu.Item>
      </Menu.Menu>
      <Menu.Menu position="right">
        <Menu.Item fitted>
          <DateControl
            prerender={prerenderDatePicker}
            earliestStartDate={START_OF_REPORTS}
          />
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  )
}
